import React from "react";

import "./ModalPageTitle.css";

const ModalPageTitle = ({ children }) => <h1 className="ModalPageTitle">{children}</h1>;

export default ModalPageTitle;
